'use client'

import React, { createContext, useContext, ReactNode } from 'react'
import { LocaleData, SupportedLocale, TOptions, createTFunction } from './i18n-server'

export interface I18nContextValue {
  locale: SupportedLocale
  messages: LocaleData
  t: (key: string | TemplateStringsArray, options?: TOptions) => string
}

export interface I18nProviderProps {
  locale: SupportedLocale
  messages: LocaleData
  children: ReactNode
}

export const I18nContext = createContext<I18nContextValue | null>(null)

export const useT = () => {
  const context = useContext(I18nContext)
  if (!context) {
    throw new Error('useT must be used within an I18nProvider')
  }
  return context.t
}

export const I18nProvider = ({ locale, messages, children }: I18nProviderProps) => {
  const t = createTFunction(locale, messages)

  const value: I18nContextValue = {
    locale,
    messages,
    t,
  }

  return React.createElement(I18nContext.Provider, { value }, children)
}

// Экспорт типов для удобства
export type { LocaleData, SupportedLocale, TOptions } from './i18n-server'
